// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { styled, keyframes } from "@mui/material/styles";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

// Images
// Images
import facebookLogo from "assets/images/logos/gray-logos/3.png";
import twitterLogo from "assets/images/logos/gray-logos/2.png";
import youtubeLogo from "assets/images/logos/gray-logos/4.png";
import linkedinLogo from "assets/images/logos/gray-logos/1.png";
import githubLogo from "assets/images/logos/gray-logos/5.png";

// Animation keyframes
const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

// Styled components
const LogoContainer = styled(Box)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  width: "100%",
  background:
    "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 5%, rgba(255,255,255,1) 95%, rgba(255,255,255,0) 100%)",
});

const LogoWrapper = styled(Box)({
  display: "inline-block",
  animation: `${scroll} 40s linear infinite`,
  "&:hover": {
    animationPlayState: "paused",
  },
});

const Logo = styled("img")({
  width: "120px",
  height: "auto",
  margin: "0 30px",
  opacity: 0.7,
  display: "inline-block",
  verticalAlign: "middle",
  transition: "opacity 0.3s ease",
  "&:hover": {
    opacity: 1,
  },
});

function Featuring() {
  const logos = [twitterLogo, facebookLogo, youtubeLogo, linkedinLogo, githubLogo];

  return (
    <MKBox component="section" pt={10} pb={8}>
      <Container>
        <LogoContainer sx={{ mb: 18 }}>
          <LogoWrapper>
            {logos.concat(logos, logos).map((logo, index) => (
              <Logo key={index} src={logo} alt={`Logo ${(index % logos.length) + 1}`} />
            ))}
          </LogoWrapper>
        </LogoContainer>
        <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
          <Grid item xs={12} md={3.5}>
            <DefaultCounterCard
              count={550}
              separator=","
              title="Projects"
              description="Managed by certified experts, delivering high-performance outcomes and exceeding client expectations."
            />
          </Grid>
          <Grid item xs={12} md={3.5}>
            <DefaultCounterCard
              count={1200}
              separator=","
              suffix="+"
              title="Hours"
              description="Dedicated to delivering quality work that consistently meets the high standards set by our users."
            />
          </Grid>
          <Grid item xs={12} md={3.5}>
            <DefaultCounterCard
              count={24}
              suffix="/7"
              title="Support"
              description="Providing round-the-clock assistance, ensuring timely project completion and continuous engagement with our clients."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Featuring;
